import { db } from "../../../config/firebaseconfig"
import findCollection from "./findCollection"
import updateAllGroupUAsWithStudentAll from "../../assessment/updateAllGroupUAsWithStudentAll"
import markGUAsAsNeedingUpdateAll from "../../assessment/markGUAsAsNeedingUpdateAll";

export default function deleteRecord(record) {
  const collection = findCollection(record)
  if (!collection) {
    return Promise.reject(Error('Invalid record.'))
  } else {
    return db.collection(collection).doc(record.id).update({deleted: true})
      .then(() => {
        if (record && record.role === 'Student') {
          return markGUAsAsNeedingUpdateAll(record, 2018)
            .then(() => {
              updateAllGroupUAsWithStudentAll(record, 2018)
            })
        }
      })
  }
}


// WEBPACK FOOTER //
// ./src/helpers/users/manageUsers/deleteRecord.js